import * as XLSX from 'xlsx';
import { calcLineas, fmt } from '../store';

function inRange(fecha, desde, hasta) {
  if (!desde && !hasta) return true;
  const d = new Date(fecha);
  if (desde && d < new Date(desde)) return false;
  if (hasta && d > new Date(hasta + 'T23:59:59')) return false;
  return true;
}

export function exportClientes(clientes) {
  if (!clientes.length) { alert('No hay clientes para exportar.'); return; }
  const wb = XLSX.utils.book_new();
  const datos = clientes.map(c => ({
    'Nombre / Empresa': c.nombre || '',
    'NIF/CIF':          c.nif    || '',
    'Teléfono':         c.telefono || '',
    'Email':            c.email  || '',
    'Calle':            c.calle  || '',
    'CP':               c.cp     || '',
    'Localidad':        c.localidad || '',
    'Provincia':        c.provincia || '',
    'Dirección':        c.direccion || '',
  }));
  const ws = XLSX.utils.json_to_sheet(datos);
  ws['!cols'] = [{ wch:35 },{ wch:13 },{ wch:13 },{ wch:25 },{ wch:25 },{ wch:7 },{ wch:18 },{ wch:14 },{ wch:35 }];
  XLSX.utils.book_append_sheet(wb, ws, 'Clientes');
  XLSX.writeFile(wb, `Clientes_${new Date().toISOString().slice(0,10)}.xlsx`);
}

export function exportTickets(tickets, desde, hasta, config) {
  const filtered = tickets.filter(t => inRange(t.fecha, desde, hasta));
  if (!filtered.length) { alert('No hay tickets en ese rango de fechas.'); return; }

  const wb = XLSX.utils.book_new();

  // Hoja resumen
  const resumen = filtered.map(t => {
    const { base, iva, total } = calcLineas(t.lineas);
    return { 'Nº Ticket': t.num, 'Fecha': fmt(t.fecha), 'Cliente': t.clienteNombre || '(Sin nombre)', 'Forma pago': t.pago, 'Base (€)': +base.toFixed(2), 'IVA (€)': +iva.toFixed(2), 'Total (€)': +total.toFixed(2), 'Estado': t.estado };
  });
  const ws1 = XLSX.utils.json_to_sheet(resumen);
  ws1['!cols'] = [{ wch:10 },{ wch:12 },{ wch:22 },{ wch:14 },{ wch:11 },{ wch:11 },{ wch:11 },{ wch:10 }];
  XLSX.utils.book_append_sheet(wb, ws1, 'Tickets');

  // Hoja líneas
  const lineas = [];
  filtered.forEach(t => {
    t.lineas.forEach(l => {
      lineas.push({ 'Nº Ticket': t.num, 'Fecha': fmt(t.fecha), 'Cliente': t.clienteNombre || '(Sin nombre)', 'Descripción': l.desc, 'Cant.': l.cant, 'Precio u. (€)': +l.precio.toFixed(2), 'IVA %': l.iva, 'Total línea (€)': +(l.cant*l.precio).toFixed(2) });
    });
  });
  const ws2 = XLSX.utils.json_to_sheet(lineas);
  ws2['!cols'] = [{ wch:10 },{ wch:12 },{ wch:22 },{ wch:35 },{ wch:7 },{ wch:12 },{ wch:7 },{ wch:14 }];
  XLSX.utils.book_append_sheet(wb, ws2, 'Líneas de ticket');

  // Hoja totales
  const { base: tBase, iva: tIva, total: tTotal } = filtered.reduce((acc, t) => {
    const c = calcLineas(t.lineas);
    return { base: acc.base+c.base, iva: acc.iva+c.iva, total: acc.total+c.total };
  }, { base:0, iva:0, total:0 });
  const totalesData = [
    { Concepto: 'Número de tickets', Valor: filtered.length },
    { Concepto: 'Base imponible total', Valor: +tBase.toFixed(2) },
    { Concepto: 'IVA total', Valor: +tIva.toFixed(2) },
    { Concepto: 'Total facturado', Valor: +tTotal.toFixed(2) },
    { Concepto: 'Período', Valor: `${desde || '—'} a ${hasta || '—'}` },
  ];
  const ws3 = XLSX.utils.json_to_sheet(totalesData);
  ws3['!cols'] = [{ wch:25 },{ wch:20 }];
  XLSX.utils.book_append_sheet(wb, ws3, 'Resumen');

  const nombre = `Tickets_${desde||'inicio'}_${hasta||'fin'}.xlsx`;
  XLSX.writeFile(wb, nombre);
}

export function exportFacturas(facturas, desde, hasta, config) {
  const filtered = facturas.filter(f => inRange(f.fecha, desde, hasta));
  if (!filtered.length) { alert('No hay facturas en ese rango de fechas.'); return; }

  const wb = XLSX.utils.book_new();

  const resumen = filtered.map(f => {
    const { base, iva, total } = calcLineas(f.lineas);
    const detallePago = f.pago === 'Mixto' && Array.isArray(f.pagoMixtoDetalle)
      ? f.pagoMixtoDetalle.map(d => `${d.modo}: ${(+d.importe).toFixed(2)}€`).join(' + ')
      : '';
    return { 'Nº Factura': f.num, 'Fecha': fmt(f.fecha), 'Cliente': f.clienteNombre, 'NIF/CIF': f.clienteNif || '', 'Forma pago': f.pago, 'Detalle pago': detallePago, 'Base (€)': +base.toFixed(2), 'IVA (€)': +iva.toFixed(2), 'Total (€)': +total.toFixed(2), 'Estado': f.estado };
  });
  const ws1 = XLSX.utils.json_to_sheet(resumen);
  ws1['!cols'] = [{ wch:14 },{ wch:12 },{ wch:22 },{ wch:12 },{ wch:14 },{ wch:30 },{ wch:11 },{ wch:11 },{ wch:11 },{ wch:10 }];
  XLSX.utils.book_append_sheet(wb, ws1, 'Facturas');

  const lineas = [];
  filtered.forEach(f => {
    f.lineas.forEach(l => {
      lineas.push({ 'Nº Factura': f.num, 'Fecha': fmt(f.fecha), 'Cliente': f.clienteNombre, 'Descripción': l.desc, 'Cant.': l.cant, 'Precio u. (€)': +l.precio.toFixed(2), 'IVA %': l.iva, 'Total línea (€)': +(l.cant*l.precio).toFixed(2) });
    });
  });
  const ws2 = XLSX.utils.json_to_sheet(lineas);
  ws2['!cols'] = [{ wch:14 },{ wch:12 },{ wch:22 },{ wch:35 },{ wch:7 },{ wch:12 },{ wch:7 },{ wch:14 }];
  XLSX.utils.book_append_sheet(wb, ws2, 'Líneas');

  const { base: tBase, iva: tIva, total: tTotal } = filtered.reduce((acc, f) => {
    const c = calcLineas(f.lineas);
    return { base: acc.base+c.base, iva: acc.iva+c.iva, total: acc.total+c.total };
  }, { base:0, iva:0, total:0 });
  const cobradas = filtered.filter(f=>f.estado==='Cobrada').length;
  const pendientes = filtered.filter(f=>f.estado==='Pendiente').length;
  const totalesData = [
    { Concepto: 'Total facturas', Valor: filtered.length },
    { Concepto: 'Cobradas', Valor: cobradas },
    { Concepto: 'Pendientes', Valor: pendientes },
    { Concepto: 'Base imponible total', Valor: +tBase.toFixed(2) },
    { Concepto: 'IVA total', Valor: +tIva.toFixed(2) },
    { Concepto: 'Total facturado', Valor: +tTotal.toFixed(2) },
    { Concepto: 'Período', Valor: `${desde || '—'} a ${hasta || '—'}` },
  ];
  const ws3 = XLSX.utils.json_to_sheet(totalesData);
  ws3['!cols'] = [{ wch:25 },{ wch:20 }];
  XLSX.utils.book_append_sheet(wb, ws3, 'Resumen');

  XLSX.writeFile(wb, `Facturas_${desde||'inicio'}_${hasta||'fin'}.xlsx`);
}

export function exportProveedores(proveedores) {
  if (!proveedores.length) { alert('No hay proveedores para exportar.'); return; }
  const wb = XLSX.utils.book_new();
  const datos = proveedores.map(p => ({
    'Nombre comercial': p.nombreComercial || p.nombre || '',
    'Nombre empresa':   p.nombreEmpresa   || '',
    'CIF/NIF':          p.cif       || '',
    'Teléfono':         p.telefono  || '',
    'Email':            p.email     || '',
    'Dirección':        p.direccion || '',
    'Web':              p.web       || '',
    'Contacto':         p.contacto  || '',
    'Notas':            p.notas     || '',
  }));
  const ws = XLSX.utils.json_to_sheet(datos);
  ws['!cols'] = [{ wch:28 },{ wch:28 },{ wch:13 },{ wch:14 },{ wch:25 },{ wch:35 },{ wch:22 },{ wch:20 },{ wch:30 }];
  XLSX.utils.book_append_sheet(wb, ws, 'Proveedores');
  XLSX.writeFile(wb, `Proveedores_${new Date().toISOString().slice(0,10)}.xlsx`);
}

export function exportFacturasProveedor(facturas, desde, hasta) {
  if (!facturas.length) { alert('No hay facturas de proveedor para exportar.'); return; }
  const wb = XLSX.utils.book_new();

  // Hoja principal
  const resumen = facturas.map(f => ({
    'Fecha':        fmt(f.fecha),
    'Proveedor':    f.proveedorNombre || f.proveedor || '',
    'Nº Factura':   f.numFactura || '',
    'Base (€)':     +(parseFloat(f.base)||0).toFixed(2),
    'IVA %':        f.iva ?? '',
    'Total (€)':    +(parseFloat(f.total||f.importe)||0).toFixed(2),
    'Estado':       f.estado || '',
    'Concepto':     f.concepto || '',
    'Notas':        f.notas || '',
  }));
  const ws1 = XLSX.utils.json_to_sheet(resumen);
  ws1['!cols'] = [{ wch:12 },{ wch:28 },{ wch:16 },{ wch:11 },{ wch:7 },{ wch:11 },{ wch:12 },{ wch:30 },{ wch:25 }];
  XLSX.utils.book_append_sheet(wb, ws1, 'Facturas proveedor');

  // Hoja resumen por estado
  const porEstado = {};
  facturas.forEach(f => {
    const est = f.estado || 'Sin estado';
    if (!porEstado[est]) porEstado[est] = { count:0, total:0 };
    porEstado[est].count++;
    porEstado[est].total += parseFloat(f.total||f.importe)||0;
  });
  const tTotal = facturas.reduce((s,f) => s + (parseFloat(f.total||f.importe)||0), 0);
  const totalesData = [
    ...Object.entries(porEstado).map(([est, v]) => ({ Concepto: est, 'Nº facturas': v.count, 'Total (€)': +v.total.toFixed(2) })),
    { Concepto: 'TOTAL', 'Nº facturas': facturas.length, 'Total (€)': +tTotal.toFixed(2) },
  ];
  const ws3 = XLSX.utils.json_to_sheet(totalesData);
  ws3['!cols'] = [{ wch:20 },{ wch:12 },{ wch:14 }];
  XLSX.utils.book_append_sheet(wb, ws3, 'Resumen');

  const rango = desde || hasta ? `_${desde||''}${desde&&hasta?'_':''}${hasta||''}` : `_${new Date().toISOString().slice(0,10)}`;
  XLSX.writeFile(wb, `FacturasProveedor${rango}.xlsx`);
}
